import {useDispatch, useSelector} from 'react-redux';
import {useLazyGetRevisionOptionsQuery} from '../../../../store/builder/revisiions/revisions.api';
import {setRevisionOptions} from '../../../../store/builder/revisiions/revisionsSlice';

export const useGetRevisions = () => {
  const dispatch = useDispatch();

  const [getOptions, {data}] = useLazyGetRevisionOptionsQuery();

  const {options: revisionOptions, current_option: current_revision} =
    useSelector(state => state?.rootReducer?.revisionsSlice);

  const getRevisionOptions = (current_revision = false, in_settings = null) => {
    getOptions({in_settings})
      .unwrap()
      .then(res => {
        let data = res?.map(item => ({...item, value: item?.code}));
        dispatch(setRevisionOptions({data, current_revision}));
      })
      .catch(err => {
        console.log(err);
      });
  };

  return [getRevisionOptions, revisionOptions, current_revision];
};
